// (function () {
//   function pad(n) {
//     return n < 10 ? '0' + n : n;
//   }

//   // Returns Pacific Time (handles DST)
//   function getPacificTimeDate() {
//     const now = new Date();

//     // DST start: 2nd Sunday in March
//     const startDST = new Date(now.getFullYear(), 2, 8, 2, 0, 0, 0);
//     startDST.setDate(8 + ((7 - startDST.getDay()) % 7));

//     // DST end: 1st Sunday in November
//     const endDST = new Date(now.getFullYear(), 10, 1, 2, 0, 0, 0);
//     endDST.setDate(1 + ((7 - endDST.getDay()) % 7));

//     const isDST = now >= startDST && now < endDST;
//     const offset = isDST ? -7 : -8; // PDT/PST

//     const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
//     const pacific = new Date(utc.getTime() + offset * 60 * 60000);
//     return pacific;
//   }

//   function updateCountdown() {
//     const pacific = getPacificTimeDate();

//     // Cutoff: 12:00:00 PM Pacific Time
//     const cutoffToday = new Date(pacific);
//     cutoffToday.setHours(12, 0, 0, 0); // Noon

//     let timerHTML = '';
//     if (pacific < cutoffToday) {
//       // Countdown in HH:MM:SS format
//       let diff = cutoffToday - pacific;
//       if (diff < 0) diff = 0;
//       const hours = Math.floor(diff / 3600000);
//       const minutes = Math.floor((diff % 3600000) / 60000);
//       const seconds = Math.floor((diff % 60000) / 1000);
//       const countdown = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
//       timerHTML = `Order in <span class="countdown_time_mdrbd" >${countdown}</span> for your order to ship today!`;
//     } else {
//       timerHTML = `<span style="color:#000;">Order before midnight to ship out tomorrow!</span>`;
//     }

//     const el = document.getElementById('cp-countdown-timer');
//     if (el) el.innerHTML = `<span style="color:black;">${timerHTML}</span>`;
//   }

//   updateCountdown();
//   setInterval(updateCountdown, 1000);
// })();

(function () {
  function pad(n) { return n < 10 ? '0' + n : n; }

  // Pacific Time (PDT/PST) with US DST rules
  function getPacificTimeDate() {
    const now = new Date();
    const startDST = new Date(now.getFullYear(), 2, 8, 2, 0, 0, 0); // 2nd Sun Mar
    startDST.setDate(8 + ((7 - startDST.getDay()) % 7));
    const endDST = new Date(now.getFullYear(), 10, 1, 2, 0, 0, 0); // 1st Sun Nov
    endDST.setDate(1 + ((7 - endDST.getDay()) % 7));
    const isDST = now >= startDST && now < endDST;
    const offsetHours = isDST ? -7 : -8; // PDT/PST
    const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    return new Date(utc.getTime() + offsetHours * 60 * 60000);
  }

  function formatHMS(ms) {
    if (ms < 0) ms = 0;
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  }

  function nextMondayStart(pt) {
    const target = new Date(pt);
    const day = pt.getDay(); // 0=Sun ... 6=Sat
    const daysToMonday = (1 - day + 7) % 7 || 7; // if Mon already, push to next Mon
    target.setDate(target.getDate() + daysToMonday);
    target.setHours(0, 0, 0, 0); // 00:00:00
    return target;
  }

  function updateCountdown() {
    const nowPT = getPacificTimeDate();
    const day = nowPT.getDay(); // 0=Sun ... 6=Sat
    const noonToday = new Date(nowPT);
    noonToday.setHours(12, 0, 0, 0); // 12:00:00 PM

    let html = '';

    if (day === 6 || day === 0) {
      // Sat / Sun -> ship Monday (countdown to Monday 00:00)
      const target = nextMondayStart(nowPT);
      html = `Order before <span class="countdown_time_mdrbd">${formatHMS(target - nowPT)}</span> to ship out on Monday!`;

    } else if (day === 5) {
      // Friday
      if (nowPT < noonToday) {
        // Before 12 PM Friday -> ship today
        html = `Order in <span class="countdown_time_mdrbd">${formatHMS(noonToday - nowPT)}</span> for your order to ship today!`;
      } else {
        // 12:00:00 PM Friday or later -> ship Monday
        const target = nextMondayStart(nowPT);
        html = `Order before <span class="countdown_time_mdrbd">${formatHMS(target - nowPT)}</span> to ship out on Monday!`;
      }

    } else {
      // Mon–Thu
      if (nowPT < noonToday) {
        html = `Order in <span class="countdown_time_mdrbd">${formatHMS(noonToday - nowPT)}</span> for your order to ship today!`;
      } else {
        html = `<span style="color:#000;">Order before midnight to ship out tomorrow!</span>`;
      }
    }

    const el = document.getElementById('cp-countdown-timer');
    if (el) el.innerHTML = `<span style="color:black;">${html}</span>`;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
})();




